import { ReactNode } from 'react'
import {
  Card,
  SectionBody,
  SectionHeading,
  PrimaryButton as StyledPrimaryButton,
} from './styles'

export interface SectionProps {
  title: string
  children?: ReactNode
  actionLabel?: string
  onAction?: () => void
}

export const Section = ({ title, children, actionLabel, onAction }: SectionProps) => {
  return (
    <Card>
      <SectionBody>
        <SectionHeading>{title}</SectionHeading>
        {children}
      </SectionBody>
      {actionLabel !== undefined && onAction !== undefined && (
        <StyledPrimaryButton type="button" onClick={onAction}>
          {actionLabel}
        </StyledPrimaryButton>
      )}
    </Card>
  )
}
